module.exports = __webpack_public_path__ + "static/parade-2019-house17-a874c56870c47bbe912652d8ae34b46a.jpg";